import {
  AdvancedMarker,
  APIProvider,
  Map as GoogleMap,
} from '@vis.gl/react-google-maps'
import { twMerge } from 'tailwind-merge'

import { IconMapSearchPin } from '~/components'

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? ''
const GOOGLE_MAP_ID = import.meta.env.VITE_GOOGLE_MAP_ID ?? ''

type Props = {
  latitude: number
  longitude: number
  className?: string
}

export const OfficeDetailMap = ({ latitude, longitude, className }: Props) => {
  const defaultCenter = { lat: latitude, lng: longitude }

  return (
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
      <GoogleMap
        className={twMerge('h-[270px] w-full md:h-[337px]', className)}
        defaultCenter={defaultCenter}
        defaultZoom={14}
        mapId={GOOGLE_MAP_ID}
        mapTypeControl={false}
        reuseMaps
      >
        <AdvancedMarker position={{ lat: latitude, lng: longitude }}>
          <IconMapSearchPin className="h-9 w-auto" />
        </AdvancedMarker>
      </GoogleMap>
    </APIProvider>
  )
}
